export const DateFormats = [
  { id: "dd-MM-yyyy", name: "dd/MM/yyyy" },
  { id: "MM-dd-yyyy", name: "MM/dd/yyyy" },
  { id: "yyyy-MM-dd", name: "yyyy/MM/dd" },
];
